import { createSelector } from 'reselect';
import { initialState } from './reducer';

const selectGlobal = (state) => state.filter || initialState;

const makeSelectStructureFilterMenuStatus = () =>
  createSelector(selectGlobal, (filterState) => filterState.structureFilterMenuStatus);

export { makeSelectStructureFilterMenuStatus };
